var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("title-component"),
      _vm._v(" "),
      _c("b-form", [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-sm-12" },
            [
              _c("card-title-component", {
                attrs: { title: _vm.$t("photos.title") }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "card-content" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("input", {
                        ref: "photoInput",
                        staticStyle: { visibility: "hidden" },
                        attrs: {
                          id: "photoInput",
                          type: "file",
                          accept: "image/*"
                        },
                        on: { change: _vm.fileChosen }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.chunkedPhotos, function(photos) {
                        return _c("div", { key: photos.id }, [
                          _c(
                            "div",
                            { staticClass: "row image-row" },
                            _vm._l(photos, function(photo) {
                              return _c(
                                "div",
                                { key: photo.id, staticClass: "col-3" },
                                [
                                  _c(
                                    "a",
                                    { attrs: { href: "javascript:void(0)" } },
                                    [
                                      _c("div", { staticClass: "image" }, [
                                        _c("img", {
                                          staticClass:
                                            "thumbnail img img-responsive full-width",
                                          attrs: {
                                            src: photo.oURL,
                                            id: photo.name
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.showModal(photo.id)
                                            }
                                          }
                                        })
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-modal",
                                    {
                                      ref: _vm.getValidID(photo.id),
                                      refInFor: true,
                                      attrs: {
                                        id: _vm.getValidID(photo.id),
                                        title: photo.name,
                                        size: "lg",
                                        "hide-footer": true
                                      }
                                    },
                                    [
                                      _c("b-img", {
                                        attrs: {
                                          fluid: "",
                                          src: photo.oURL,
                                          id: _vm.getValidID(photo.name)
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "spacer" }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "trash-icon" }, [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: "javascript:void(0)"
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.deletePhoto(photo.id)
                                              }
                                            }
                                          },
                                          [
                                            _c("icon", {
                                              attrs: { name: "trash-o" }
                                            })
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            })
                          )
                        ])
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "add-link" }, [
                      _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function($event) {
                              _vm.openInput("photo")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.$t("photos.addPhotoButton")) +
                              "\n                                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "b-popover",
                              rawName: "v-b-popover.hover",
                              value: _vm.$t("photos.popover"),
                              expression: "$t('photos.popover')",
                              modifiers: { hover: true }
                            }
                          ],
                          staticClass: "popover-trigger"
                        },
                        [_c("icon", { attrs: { name: "info-circle" } })],
                        1
                      )
                    ])
                  ])
                ])
              ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-sm-12" },
            [
              _c("card-title-component", {
                attrs: { title: _vm.$t("videos.title") }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "card-content" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "add-link" }, [
                      _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function($event) {
                              _vm.openVideoInput("video")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.$t("videos.addVideoButton")) +
                              "\n                                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "b-popover",
                              rawName: "v-b-popover.hover",
                              value: _vm.$t("videos.popover"),
                              expression: "$t('videos.popover')",
                              modifiers: { hover: true }
                            }
                          ],
                          staticClass: "popover-trigger"
                        },
                        [_c("icon", { attrs: { name: "info-circle" } })],
                        1
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col general-docs-item" },
                    [
                      _c("input", {
                        ref: "videoInput",
                        staticStyle: { visibility: "hidden" },
                        attrs: {
                          id: "videoInput",
                          type: "file",
                          accept: "video/*"
                        },
                        on: { change: _vm.videoChosen }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.documents.videos, function(video) {
                        return _c("div", { key: video.id }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function($event) {
                                  _vm.downloadVideo(video.id, video.name)
                                }
                              }
                            },
                            [
                              _c("icon", { attrs: { name: "film" } }),
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(video.name) +
                                  "\n                                "
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function($event) {
                                  _vm.deleteVideo(video.id)
                                }
                              }
                            },
                            [_c("icon", { attrs: { name: "trash-o" } })],
                            1
                          )
                        ])
                      })
                    ],
                    2
                  )
                ])
              ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "row video-player-container",
            class: { "player-is-not-shown": this.videoNotLoaded }
          },
          [
            _c("div", { staticClass: "col" }, [
              _c(
                "div",
                { staticClass: "embed-responsive embed-responsive-1by1" },
                [
                  _c(
                    "video",
                    {
                      attrs: {
                        controls: "",
                        id: "video-player",
                        muted: "true"
                      },
                      domProps: { muted: true }
                    },
                    [
                      _c("source", { attrs: { src: "" } }),
                      _vm._v(
                        "\n                        Your browser does not support the video tag.\n                    "
                      )
                    ]
                  )
                ]
              )
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03383d08", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03383d08","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PhotosComponent.vue
// module id = null
// module chunks = 